import React from 'react'
import './service-card.css'
import Image006 from '../../../assets/img006.png'
import Image007 from '../../../assets/img007.png'
import Image008 from '../../../assets/img008.png'
import Image009 from '../../../assets/img009.png'
import Image010 from '../../../assets/img010.png'
import Image011 from '../../../assets/img011.png'
import Image012 from '../../../assets/img012.png'
import Image013 from '../../../assets/img013.png'
import Image014 from '../../../assets/img014.png'
import Image015 from '../../../assets/img015.png'
import Image016 from '../../../assets/img016.png'

const image = {
    cortemasc: Image006,
    barba: Image007,
    cortemascbarba: Image008,
    pezinho: Image009,
    sobrancelha: Image010,
    cortefem: Image011,
    escova: Image012,
    pintura: Image013,
    corteinf: Image014,
    cortemaq: Image015,
    cortedes: Image016
}

const ServiceCard = ({ Icon, Label, Time, Price, Action }) => {

    return (
        <div>
            <button className='service-card' onClick={Action}>

                <span className="check">✓</span>
                <span className="uncheck">✓</span>
                
                <div className="service-card-icon">
                    <img src={image[Icon]} alt="Serviço" />
                </div>

                <div className="service-card-content">
                    <p className='service-name app-little-title'>{Label}</p>
                    <p className='service-time app-little-title'>◷ {Time}</p>
                    <p className='service-price app-little-title'>{Price}</p>
                </div>
            </button>
        </div>
    )
}

export default ServiceCard